import { lazy } from 'react'
import { VStack, Box } from '@chakra-ui/react'
import { observer } from 'mobx-react'
import { Outlet, Route, Routes } from 'react-router-dom'
import routes from 'routes'
import AdminHeader from 'components/AdminHeader'

const AdminLayout = () => {
  return (
    <Box minHeight="100vh" background="linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)">
      <AdminHeader />
      <Box 
        maxWidth="1200px" 
        margin="0 auto" 
        padding={{ base: 6, lg: 8 }}
        minHeight="calc(100vh - 70px)"
      >
        <Box
          background="white"
          borderRadius="16px"
          boxShadow="0 10px 25px rgba(0, 0, 0, 0.1)"
          padding={{ base: 6, lg: 8 }}
          minHeight="600px"
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  )
}

const AdminPage = lazy(() => import('pages/AdminPage'))
const CompanyReportPage = lazy(() => import('pages/CompanyReportPage'))
const CompanyDetailPage = lazy(() => import('pages/CompanyDetailPage'))
const AdminReleaseNotesPage = lazy(() => import('pages/AdminReleaseNotesPage'))

const AdminRoutes = () => {
  return (
    <Routes>
      <Route element={<AdminLayout />}>
        <Route path={routes.admin.value} element={<AdminPage />} />
        <Route path={routes.admin.report.value} element={<CompanyReportPage />} />
        <Route path={`${routes.admin.report.value}/:organizationId`} element={<CompanyDetailPage />} />
        <Route path={routes.admin.releaseNotes.value} element={<AdminReleaseNotesPage />} />
      </Route>
    </Routes>
  )
}

export default observer(AdminRoutes)
